import type {Video} from "~/types/video";


export function useVideo() {

  const converters = useConverters();

  const getVideoChaptersBlobUrl = (video: Video) => {

    if(!video?.sections || !video.sections.length) {
      return null;
    }

    let vtt = 'WEBVTT\n\n';
    for (const [i, section] of video.sections.entries()) {
      const start = converters.millisecondsToTimeStamp(section.start_ms);
      const end = converters.millisecondsToTimeStamp(section.end_ms);
      vtt += `${i + 1}\n${start} --> ${end}\n${section.title}\n\n`;
    }

    return URL.createObjectURL(new Blob([vtt], { type: 'text/vtt' }));
  }

  const getVideoMomentChaptersBlobUrl = (title: string, start_ms: number, end_ms: number) => {
    let vtt = 'WEBVTT\n\n';
    vtt += `1\n${converters.millisecondsToTimeStamp(start_ms)} --> ${converters.millisecondsToTimeStamp(end_ms)}\n${title}\n\n`;

    return URL.createObjectURL(new Blob([vtt], { type: 'text/vtt' }));
  }

  return {
    getVideoChaptersBlobUrl,
    getVideoMomentChaptersBlobUrl
  }

}
